module.exports = __webpack_public_path__ + "img/Ferimentos e aberturas naturais macieira - Colheita 3.c0568c94.webp";